import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia
} from "@mui/material";
import { motion } from "framer-motion";

import localProductionImg from "../../assets/image/landing/production.png";
import partnershipsImg from "../../assets/image/landing/partnership.png";
import innovationImg from "../../assets/image/landing/innovative.png";

const CompetitiveAdvantageSectionComponent = () => {

    const items = [
        // {
        //     title: "Local Production Focus",
        //     description:
        //         "RDX prioritizes local manufacturing of security technologies and infrastructure, meeting its objectives to minimize imports and enhance local economic development.",
        //     image: localProductionImg
        // },
        {
            title: "Strong Partnerships",
            description:
                "RDX strongly works with both local and international partners, utilizing diverse expertise to deliver comprehensive solutions.",
            image: partnershipsImg
        },
        {
            title: "Innovative Product Range",
            description:
                "RDX offers a wide array of security products and infrastructure solutions, making it a one-stop provider for national security needs.",
            image: innovationImg
        }
    ];

    return (
        <Box
            id="competitive-advantage"
            sx={{
                py: { xs: 6, md: 10 },
                backgroundColor: "#f2f2f2",
                overflow: "hidden"
            }}
        >
            <Box className="containerMain" sx={{ px: { xs: 3, md: 0 } }}>
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 700,
                            color: "#08244d",
                            mb: 2,
                            textAlign: "center",
                            fontSize: { xs: "2rem", md: "3rem" }
                        }}
                    >
                        Competitive Advantage
                    </Typography>

                    <Typography
                        variant="h6"
                        sx={{
                            color: "#000",
                            mb: { xs: 5, md: 8 },
                            textAlign: "center",
                            maxWidth: "800px",
                            mx: "auto",
                            fontSize: { xs: "1rem", md: "1.25rem" }
                        }}
                    >
                        Why global defense leaders and innovators choose Radix.
                    </Typography>
                </motion.div>

                <Grid container spacing={4}>
                    {items.map((item, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{
                                    duration: 0.5,
                                    delay: index * 0.1
                                }}
                                style={{ height: "100%" }}
                            >
                                <Card
                                    sx={{
                                        height: "100%",
                                        position: "relative", // IMPORTANT
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 4
                                    }}
                                >
                                    {/* Image */}
                                    <Box
                                        sx={{
                                            height: { xs: 220, md: 280 },
                                            overflow: "hidden",
                                            position: "relative"
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={item.image}
                                            alt={item.title}
                                            sx={{
                                                height: "100%",
                                                objectFit: "cover"
                                            }}
                                        />
                                    </Box>

                                    <CardContent
                                        sx={{
                                            p: 3,
                                            position: "relative",
                                            overflow: "hidden"
                                        }}
                                    >
                                        {/* Large Background Number */}
                                        <Typography
                                            sx={{
                                                position: "absolute",
                                                top: 20,
                                                left: 5,
                                                fontSize: { xs: "4rem", md: "5rem" },
                                                fontWeight: 800,
                                                color: "#08244d",
                                                opacity: 0.06,
                                                lineHeight: 1,
                                                zIndex: 0,
                                                pointerEvents: "none"
                                            }}
                                        >
                                            {String(index + 1).padStart(2, "0")}
                                        </Typography>

                                        {/* Content */}
                                        <Box
                                            sx={{
                                                position: "relative",
                                                zIndex: 2,
                                                pt: { xs: 4, md: 5 }, // pushes content BELOW the number
                                                textAlign: "left"
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontWeight: 700,
                                                    color: "#08244d",
                                                    mb: 1,
                                                    fontSize: { xs: "1.25rem", md: "1.5rem" },
                                                    textAlign: "left"
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Box
                                                sx={{
                                                    width: 60,
                                                    height: 4,
                                                    backgroundColor: "#4facfe",
                                                    borderRadius: 2,
                                                    mb: 2
                                                }}
                                            />

                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: "#000",
                                                    lineHeight: 1.6,
                                                    textAlign: "left",
                                                    fontSize: { xs: "0.9rem", md: "1rem" }
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        </Box>
                                    </CardContent>


                                </Card>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default CompetitiveAdvantageSectionComponent;
